import { render } from "./VisaMessage.vue?vue&type=template&id=5a06e754&scoped=true"
import script from "./VisaMessage.vue?vue&type=script&lang=js"
export * from "./VisaMessage.vue?vue&type=script&lang=js"

import "./VisaMessage.vue?vue&type=style&index=0&id=5a06e754&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a06e754"]])

export default __exports__